import * as z from "zod";
import { QUALITY_CHECK_NAMES } from "./enums";

type QualityCheckDefaults = Record<(typeof QUALITY_CHECK_NAMES)[number], boolean>;

const CHECK_LABELS: Record<(typeof QUALITY_CHECK_NAMES)[number], string> = {
	GeneralPlacementError: "General Placement Error",
	NotInsideCameraView: "Not Inside Camera View",
	NotCloseEnough: "Not Close Enough",
	NotBackSide: "Not Back Side",
	NotFrontSide: "Not Front Side",
	NotSteady: "Not Steady",
	Slower: "Slower",
	BlurryPhoto: "Blurry Photo",
};

/**
 * Build a quality-checks z.object where every field is `z.boolean().default(…)`.
 * Pass a map of defaults to control which checks start enabled/disabled.
 */
export function buildQualityChecksSchema(defaults: QualityCheckDefaults) {
	// `Object.fromEntries` widens the keys to `string`, which would infer the config
	// field as `Record<string, boolean>`; naming the shape keeps each check a known
	// property so consumers can index it exhaustively.
	type Shape = { [K in (typeof QUALITY_CHECK_NAMES)[number]]: z.ZodDefault<z.ZodBoolean> };
	const shape = Object.fromEntries(
		QUALITY_CHECK_NAMES.map((name) => [name, z.boolean().default(defaults[name]).describe(CHECK_LABELS[name])]),
	) as Shape;
	return z.object(shape);
}
